// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { generateId } from '../../_common/api/utility';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import LoyaltyCard from '../LoyaltyCard';
import HomeCard from '../HomeCard';
import GiftBalanceCard from '../GiftBalanceCard';
import { HasFeature, Features } from '../../_common/RequireFeature';

const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    padding: 0 1.5em 0.7em 1.5em;
    justify-content: space-between;
    animation: slideInFromRight 0.3s;

    gap: 0.5em;
`

const SummaryRow = styled.div`
    width: 100%;
    display: flex;
    gap: 0.8em;
`

const Home = ({ ...props }) => {
    const {
        state: {
            site_config,
            active_user,
        },
        getUnreadNotifications
    } = useGlobalState();

    const eGiftEnabled = HasFeature(Features.AppCredit) && site_config.giftCardHomeWidget;

    useEffect(() => {
        if (active_user.isLoggedIn) {
            getUnreadNotifications();
        }
    }, [])

    return (
        <>
        
        <Col>
            {
                site_config.loyaltyProgram || eGiftEnabled ?
                    active_user?.isLoggedIn ?
                        eGiftEnabled ?
                            <SummaryRow>
                                <GiftBalanceCard />
                                {site_config.loyaltyProgram ? <LoyaltyCard compact /> : null}
                            </SummaryRow>
                            : site_config.loyaltyProgram ? <LoyaltyCard compact solo /> : null
                        : eGiftEnabled ?
                            site_config.loyaltyProgram ?
                                <SummaryRow>
                                    <GiftBalanceCard guest />
                                    <LoyaltyCard compact guest />
                                </SummaryRow>
                                : <GiftBalanceCard guest solo />
                            : site_config.loyaltyProgram ? <LoyaltyCard compact solo guest /> : null
                    : null
            }
            {
                site_config.homeCards.map((e, i) =>
                    <HomeCard
                        key={generateId()}
                        index={i}
                        to={e.to}
                        text={e.text}
                        icon={e.icon}
                    />
                )
            }
        </Col>
        </>
    );
}

export default Home;